import { Tracker } from '@leverege/molten/tracking'

/**
 * Extracts the section name from the action options
 * @param {Object} options - The action options
 * @returns {string} The section name
 */
const getSectionName = ( { action } ) => action.layout.sectionName

const getBlueprintName = ( pluginId ) => {
  if ( !pluginId ) return null
  const parts = pluginId.split( '.' )
  return parts[parts.length - 2]
}

/**
 * Analytics mutator that tracks plugin actions
 * @param {string} type - The mutator type
 * @param {Object} plugin - The plugin to mutate
 * @param {Object} molten - The molten instance
 * @returns {Object} The mutated plugin
 */
export default function AnalyticsMutator( type, plugin, molten ) {

  const pluginId = plugin?.id
  
  const isAction = pluginId?.startsWith( 'blueprint.action' )
  
  if ( !isAction ) return plugin
  
  const actionsToTrack = [ 'CreateItem', 'UpdateItem', 'DeleteItem', 'RemoveItem', 'BulkCreateItem', 'BulkUpdateItem' ]

  const eventType = pluginId?.replace( 'blueprint.action.', '' )
  
  const shouldTrack = isAction && actionsToTrack.some( action => pluginId?.includes( action ) )

  return {
    ...plugin,
    perform : ( options ) => {
      if ( shouldTrack ) {
        Tracker.event( 'Action Initiated', {
          eventType,
          from : getSectionName( options ),
          blueprint : getBlueprintName( pluginId ),
          url : window.location.href
        } )
      }

      return plugin.perform( options )
    }
  }
}
